import { InThePress } from "./InThePress";

export const UniversalRender = InThePress;
